import { get, last } from 'lodash'
import Yggdrasil from 'services/yggdrasil'

const state = {
    quiz: null,
    lastClickedMicroLearningSection: null
}

const mutations = {
    ASSIGN_QUIZ (state, quiz) {
        state.quiz = quiz
    },
    ASSIGN_LAST_CLICKED_MICROLEARNING_SECTION (state, section) {
        state.lastClickedMicroLearningSection = section
    }
}

const actions = {
    async loadQuizByElementId(store, elementId) {
        const quiz = await Yggdrasil.loadQuizByElementId(elementId)
        store.commit('ASSIGN_QUIZ', quiz)
    },
    async sendQuizAnswers(store, results) {
        console.log('Sending quiz answers', results)
        try {
            await Yggdrasil.sendQuizAnswers(results)
        }
        catch (error) {
            console.error('Error sending quiz answers:', error)
            throw error
        }
    },
    setLastClickedMicroLearningSection(store, section) {
        store.commit('ASSIGN_LAST_CLICKED_MICROLEARNING_SECTION', section)
    },
}

const getters = {
    getQuiz: (state) => state.quiz,
    getLastClickedMicroLearningSection: (state) => state.lastClickedMicroLearningSection
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
